import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categoryDetails } from '@/mocks/content';
import { categoryVideoImages } from '@/mocks/images';

const categoryImageKeys: Record<string, number[]> = {
  remen: [1001, 1002, 1003, 1004, 1005, 1006],
  zuixin: [2001, 2002, 2003, 2004, 2005, 2006],
  dianying: [3001, 3002, 3003, 3004, 3005, 3006],
  dianshiju: [4001, 4002, 4003, 4004, 4005, 4006],
  zongyi: [5001, 5002, 5003, 5004, 5005, 5006],
  dongman: [6001, 6002, 6003, 6004, 6005, 6006],
  jilupian: [7001, 7002, 7003, 7004, 7005, 7006],
  duanshipin: [8001, 8002, 8003, 8004, 8005, 8006],
};

export default function CategoryDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryDetails[slug] : null;

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-20 text-center">
            <i className="ri-error-warning-line text-5xl text-foreground-300 mb-4 block"></i>
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-2">分类未找到</h1>
            <p className="text-foreground-500 mb-6">该分类不存在或已下架</p>
            <Link to="/category" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-left-line"></i>
              返回分类列表
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const imageKeys = slug ? (categoryImageKeys[slug] || []) : [];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 91在线视频`,
            description: category.description,
            url: `https://www.91zaixianshipin.com/category/${slug}`,
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.91zaixianshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '视频分类',
                item: 'https://www.91zaixianshipin.com/category',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: category.name,
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap">
              <Link to="/" className="hover:text-accent-600 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to="/category" className="hover:text-accent-600 transition-colors whitespace-nowrap">视频分类</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium whitespace-nowrap">{category.name}</span>
            </nav>
            <div className="flex items-center gap-4 mb-3">
              <div className="w-14 h-14 bg-accent-100 rounded-2xl flex items-center justify-center">
                <i className={`${category.icon} text-2xl text-accent-600`}></i>
              </div>
              <div>
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-foreground-500 mt-1">{category.description}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {category.videos.map((video, idx) => {
              const imageUrl = categoryVideoImages[imageKeys[idx]] || '';
              return (
                <div key={video.id} className="group rounded-2xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all duration-300 border border-background-200/70">
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={imageUrl}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                        {video.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {video.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2">
                      {video.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}